import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class DataCyclesService {
  constructor(private http: HttpClient) {}

  public fetchDataCycles(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/list`
    return this.http.post(url, params)
  }
  public fetchDataCycle(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/${id}`
    return this.http.get(url, {})
  }

  public deleteDataCycle(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/${id}`
    return this.http.delete(url)
  }

  public createDataCycle(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle`
    return this.http.post(url, params)
  }

  public updateDataCycle(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/${id}`
    return this.http.put(url, params)
  }

  public fetchBatchTaskStatus(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/switchJobStatus`
    return this.http.get(url, params)
  }

  public fetchDataCycleStats(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/stats`
    return this.http.get(url, params)
  }

  public switchDataCycle(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/switchTo/${id}`
    return this.http.get(url, {})
  }

  public stopDataCycleSwitching(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/forceStop`
    return this.http.get(url, {})
  }

  public fetchInitSwitchStats(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/datacycle/initSwitchStats`
    return this.http.get(url, {})
  }
}
